export default [
  {
    code: '+62',
    name: 'Indonesia',
    short: 'ID'
  },
  {
    code: '+65',
    name: 'Singapore',
    short: 'SG'
  },
  {
    code: '+673',
    name: 'Brunei Darussalam',
    short: 'BN'
  },
  {
    code: '+82',
    name: 'South Korea',
    short: 'KR'
  },
  {
    code: '+86',
    name: 'China',
    short: 'CN'
  },
  {
    code: '+1',
    name: 'United States',
    short: 'US'
  },
  {
    code: '+60',
    name: 'Malaysia',
    short: 'MY'
  },
  {
    code: '+66',
    name: 'Thailand',
    short: 'TH'
  },
  {
    code: '+84',
    name: 'Vietnam',
    short: 'VN'
  },
  {
    code: '+63',
    name: 'Philippines',
    short: 'PH'
  },
  {
    code: '+81',
    name: 'Japan',
    short: 'JP'
  },
  {
    code: '+966',
    name: 'Saudi Arabia',
    short: 'SA'
  },
  {
    code: '+44',
    name: 'UK',
    short: 'GB'
  },
  {
    code: '+61',
    name: 'Australia',
    short: 'AU'
  },
  {
    code: '+33',
    name: 'France',
    short: 'FR'
  },
  {
    code: '+49',
    name: 'Germany',
    short: 'DE'
  },
  {
    code: '+31',
    name: 'Netherlands',
    short: 'NL'
  },
  {
    code: '+353',
    name: 'Ireland',
    short: 'IE'
  },
  {
    code: '+91',
    name: 'India',
    short: 'IN'
  },
  {
    code: '+32',
    name: 'Belgia',
    short: 'BE'
  },
  {
    code: '+43',
    name: 'Austria',
    short: 'AT'
  },
  {
    code: '+55',
    name: 'Brazil',
    short: 'BR'
  },
  {
    code: '+64',
    name: 'New Zealand',
    short: 'NZ'
  },
  {
    code: '+34',
    name: 'Spain',
    short: 'ES'
  },
  {
    code: '+855',
    name: 'Cambodia',
    short: 'KH'
  },
  {
    code: '+46',
    name: 'Sweden',
    short: 'SE'
  },
  {
    code: '+39',
    name: 'Italy',
    short: 'IT'
  },
  {
    code: '+41',
    name: 'Switzerland',
    short: 'CH'
  },
  {
    code: '+995',
    name: 'Georgia',
    short: 'GE'
  },
  {
    code: '+42',
    name: 'Slovakia',
    short: 'SK'
  },
  {
    code: '+40',
    name: 'Romania',
    short: 'RO'
  },
  {
    code: '+216',
    name: 'Tunisia',
    short: 'TN'
  },
  {
    code: '+971',
    name: 'UAE',
    short: 'AE'
  }
];
